import Vue from 'vue'
import VueRouter from 'vue-router'
 


Vue.use(VueRouter)

import Home from '@/components/pages/Home'
import ShoppingCard from '@/components/pages/ShoppingCard'
import Category from '@/components/pages/Category'

export default new VueRouter({
//   router,
  mode:'hash',
  routes:[
    { path: '/', component: Home, name:'home' },
    { path:'/card', component:ShoppingCard, name:'shoppingcard'},
    { path:'/category/:id/:name', component:Category, name:"Category"}
  ]
})
